module.exports = __webpack_public_path__ + "static/img/8.557141be.png";